import { SceneType } from '../../services/mfeRouterService/types';
import { getServices } from '../../infra/commonInitializer';
import bindAllMethods from '../../utils/bindAllMethods';

export default class NavigationElementsBeforeInitBehavior {
  constructor() {
    bindAllMethods(this);
  }
  public init(): void {
    const { mfeRouterService } = getServices();
    mfeRouterService.listen(this._handleRouterChange);
    const state = mfeRouterService.getState();
    this._handleRouterChange(state);
  }

  private _lastRouteKey: string | undefined;
  private _count = 0;
  private _handleRouterChange(state: SceneType) {
    const { routesService, navigationService } = getServices();

    if (this._lastRouteKey === state?.content?.key) return;
    this._lastRouteKey = state?.content?.key;
    const thisCount = ++this._count;
    const thisRoute = routesService.findRouteByKey(state?.content?.key);
    const navigationElements = thisRoute?.navigationElements;

    if (!navigationElements) return;
    for (const name in navigationElements) {
      if (thisCount !== this._count) {
        break;
      } else {
        const navigationElement = navigationService.getNavigationElement(name);
        const input = navigationElements?.[name];
        if (navigationElement && input && thisCount === this._count) {
          navigationElement.setState(input);
        }
      }
    }
  }
}
